import { render, staticRenderFns } from "./SummaryRequests.vue?vue&type=template&id=108f22af&scoped=true"
import script from "./SummaryRequests.vue?vue&type=script&lang=js"
export * from "./SummaryRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108f22af",
  null
  
)

export default component.exports